import React from 'react'
import moment from 'moment'
import * as jsPDF from 'jspdf'
import { get } from 'Services/Firebase'
import { Pulse } from 'better-react-spinkit'
import { toFriendlyDate } from 'Utils/format'
import { compose, withState, lifecycle, renderComponent, branch, withProps } from 'recompose'
import logo from '../../Images/digicall_logo.png';
import PdfStyles from './styles'

const doc = new jsPDF('p', 'pt', 'letter')

const space = (col1Str, maxLength = 45) => '#'.repeat(maxLength - col1Str.length)

class InsuranceCert extends React.Component {
  constructor (props) {
    super(props);
    this.pdfRef = React.createRef()
  }

  componentDidMount () {
    var img = new Image()
    img.src = logo
    img.addEventListener('load', () => {
      doc.addImage(img, 'png', 400, 20, 150, 60)
      doc.fromHTML(
        this.pdfRef.current,
        30,
        30,
        { width: 1100 },
        () => {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('style','position:fixed;right:0; top:0; bottom:0; height:100%; width:100%; z-index: 9999;');
          document.body.appendChild(iframe);
          iframe.src = doc.output('datauristring');
        })
    })
  }

  render () {
    const { claimDetails } = this.props
    return (
      <PdfStyles ref={this.pdfRef}>
        <h3 className='title'>PLUMBING CLEARANCE CERTIFICATE (A2)</h3>
        <h4 className='sm-margin'>IMPORTANT INFORMATION</h4>

        <p>1. This document must only be completed when all <strong>Plumbing</strong> repairs have been satisfactorily concluded by the <strong>Plumber</strong></p>
        <p>appointed to carry out the <strong>Plumbing</strong> portion of your claim. Please note that  you may contact the <strong>Plumber</strong> should</p>
        <p className='sm-margin'>the plumbing work performed by them develop a malfunction.</p>

        <p className='sm-margin'>2. Your answers to the <strong>Service Questionnaire</strong> are monitored by the Insurer.</p>

        <p>3. Any insured item replaced such as geyser, valve, etc., is regarded as <strong>Salvage</strong> in terms of your policy and therefore</p>
        <p className='sm-margin'>is the property of the Insurer.</p>

        <p>4. It is common practice to leave the failed geyser in its current location, provided it is properly drained, this to avoid the</p>
        <p className='sm-margin'>dismantling the roof or other part of the building.</p>

        <p>5. By this notice, the Insured is informed that in terms of the Occupational Health and Safety Act 1993, it is the responsibility</p>
        <p>of the Insured to install an electrical <strong>Isolating Device</strong> in accordance with SANS 10142 at each operational Hot Water Cylinder</p>
        <p> on the premises. The Insurer takes no responsibility and will not be liable for any loss or damages caused to anyone or anything </p>
        <p className='sm-margin'>because of the absence of the isolatingdevice.</p>

        <p className='sm-margin'>6. I, the policy holder, acknowledge that I have read, understood and accept the following policy conditions in terms of:</p>
        
        <p><strong>6.1 Matching of Items (check if applicable) {claimDetails.matchOfItems ? <span style={{ color: '#61bd4f' }}>ACCEPTED</span> : ''}:</strong> Reinstatement of tiles, sanitaryware or cupboards dismantled or broken to</p>
        <p className='sm-margin'>enable a plumbing repair, will be rectified using similar item(s) if the same item(s) are no longer available.</p>

        <p><strong>6.2 Inactive Policy <span style={{ color: '#61bd4f' }}>ACCEPTED</span>:</strong> Should my insurance policy be inactive or the specific loss excluded, then I will be liable</p>
        <p className='sm-margin'>to pay the full amount due for the remedial plumbing work.</p>

        <p><strong>6.3 Excess (First Amount Payable) <span style={{ color: '#61bd4f' }}>ACCEPTED</span>:</strong> Should the incorrect excess be collected by the Service Provider, I will be liable</p>
        <p className='sm-margin'>to pay the total amount/shortfall as soon as my Insurer becomes aware of the omission/shortfall.</p>

        <h4 className='title'>CLAIM DETAILS</h4>
        <p>
          <strong>Insured Name:</strong> {claimDetails.clientFullname}
          <span style={{ color: '#FFF' }}>{space(`Insured Name: ${claimDetails.clientFullname}`)}</span>
          <span><strong>FOGI Order No:</strong> {claimDetails.fogiOrderNo}</span>
        </p>
        <p>
          <strong>Insurance Claim No:</strong> {claimDetails.insuranceClaimNo}
          <span style={{ color: '#FFF' }}>{space(`Insurance Claim No: ${claimDetails.insuranceClaimNo}`)}</span>
          <span><strong>Insurance Clearance Code:</strong></span>
        </p>
        <p><strong>Date Work Completed:</strong> {claimDetails.dateWorkCompleted}</p>

        <h4 className='title'>SERVICE QUESTIONNAIRE</h4>
        <p>1. Rate the performance of the insurance claims representative. <strong>{claimDetails.insuranceClaimsRepRating}</strong></p>
        <p>2. Rate the performance of the plumber who carried out the remedial work. <strong>{claimDetails.plumberRating}</strong></p>
        {claimDetails.plumberServiceComment && <p className='comment'>{claimDetails.plumberServiceComment}</p>}
        <p>3. Did the plumber gain access through the roof and not the ceiling? <strong>{claimDetails.excessSettled}</strong></p>
        <p>4. Did you settle the first amount payable(Excess) with the plumber? <strong>{claimDetails.leakDetectionCarriedOut}</strong></p>
        <p>5. Did the plumber accidentally damage your property? <strong>{claimDetails.plumberDamage}</strong></p>
        {claimDetails.plumberDamageComment && <p className='comment'>{claimDetails.plumberDamageComment}</p>}
        <p>6. Further comments and arrangements {!claimDetails.furtherComments && <strong>No</strong>}</p>
        {claimDetails.furtherComments && <p className='comment'>{claimDetails.furtherComments}</p>}

        <span className='sig-label'>Client signature:</span>
        <div>
          <img src={claimDetails.base64Signature} alt='Signature' className='signature' />
        </div>

        <h5>AUDIT TRAIL</h5>
        <p className='sm-text'>
          <strong>Email sent at:</strong> {claimDetails.surveyLinkSentAt}
          <span style={{ color: '#FFF' }}>{space(`Email sent at: ${claimDetails.surveyLinkSentAt}`)}</span>
          <span><strong>Survey completed at:</strong> {claimDetails.signedAt}</span>
        </p>
        <p className='sm-text'>
          <strong>Link opened at:</strong> {claimDetails.linkOpenedAt}
          <span style={{ color: '#FFF' }}>{space(`Link opened at: ${claimDetails.linkOpenedAt}`)}}</span>
          <span><strong>Client signed at:</strong> {claimDetails.signedAt}</span>
        </p>
        <p className='sm-text'>
          <strong>Terms accepted at:</strong> {claimDetails.termsAcceptedAt}
          <span style={{ color: '#FFF' }}>{space(`Terms accepted at: ${claimDetails.termsAcceptedAt}`)}}</span>
          <span><strong>Client signed from:</strong> {claimDetails.signedFrom}</span>
        </p>
        <p className='sm-text'>
          <strong>PDF generated at:</strong> {claimDetails.termsAcceptedFrom}
          <span style={{ color: '#FFF' }}>{space(`PDF generated at: ${claimDetails.termsAcceptedFrom}`)}}</span>
          <span><strong>FOGI Order No:</strong> {claimDetails.pdfGeneratedAt}</span>
        </p>
      </PdfStyles>
    )
  }
}

export default compose(
  withState('loading', 'setLoading', false),
  withState('claimDetails', 'setClaimDetails', null),
  lifecycle({
    async componentDidMount () {
      this.props.setLoading(true)
      const { value } = await get(`claims/${this.props.match.params.claimId}`)
      if (value && value.signedAt) {
        this.props.setClaimDetails(value)
      }
      this.props.setLoading(false)
    }
  }),
  branch(({ loading }) => loading, renderComponent(() => <Pulse color='rgb(7, 71, 166)' />)),
  branch(({ claimDetails }) => !claimDetails, renderComponent(() => <p>This claim has not been submitted.</p>)),
  withProps(({ claimDetails }) => ({ claimDetails: {
    ...claimDetails,
    surveyLinkSentAt: toFriendlyDate(claimDetails.surveyLinkSentAt),
    linkOpenedAt: toFriendlyDate(claimDetails.linkOpenedAt),
    termsAcceptedAt: toFriendlyDate(claimDetails.termsAcceptedAt),
    signedAt: toFriendlyDate(claimDetails.signedAt),
    pdfGeneratedAt: toFriendlyDate(moment()),
    termsAcceptedFrom: claimDetails.termsAcceptedFrom.ip,
    signedFrom: claimDetails.signedFrom.ip
  }}))
)(InsuranceCert)


// WEBPACK FOOTER //
// ./src/Containers/ClaimPdf/ClaimPdfContainer.jsx